import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { flushMeilisearchMutation } from "@/app/Meilisearch/GraphQL/meilisearchMutations";
import { Button } from "@/components/catalyst/button";
import { useState } from "react";

const SEARCHABLE_MODELS = [
  { name: "Blocklist", class: "App\\Blocklist\\Blocklist" },
  { name: "Bookings", class: "App\\Bookings\\Bookings\\Booking" },
  { name: "Cities", class: "App\\Cities\\Cities\\City" },
  { name: "Contacts", class: "App\\Contacts\\Contacts\\Contact" },
  { name: "Invoices", class: "App\\Invoices\\Invoices\\Invoice" },
  {
    name: "Organisations",
    class: "App\\Organisations\\Organisations\\Organisation",
  },
  { name: "Payments", class: "App\\Payments\\Payments\\Payment" },
  { name: "Pro Drivers", class: "App\\ProDrivers\\ProDrivers\\ProDriver" },
  { name: "Quotes", class: "App\\Quotes\\Quotes\\Quote" },
  { name: "Relocations", class: "App\\Relocations\\Relocations\\Relocation" },
  { name: "Suppliers", class: "App\\Suppliers\\Suppliers\\Supplier" },
  { name: "Threads", class: "App\\Threads\\Threads\\Thread" },
  {
    name: "Supplier Insurance Options",
    class: "App\\Suppliers\\SupplierInsuranceOptions\\SupplierInsuranceOption",
  },
  {
    name: "Supplier Offices",
    class: "App\\Suppliers\\SupplierOffices\\SupplierOffice",
  },
  {
    name: "Supplier Purchasable Extras",
    class:
      "App\\Suppliers\\SupplierPurchasableExtras\\SupplierPurchasableExtra",
  },
  { name: "Users", class: "App\\Users\\Users\\User" },
  { name: "Vehicles", class: "App\\Vehicles\\Vehicles\\Vehicle" },
  { name: "Waitlists", class: "App\\Waitlists\\Waitlists\\Waitlist" },
  {
    name: "Work Order Assignments",
    class:
      "App\\ProDrivers\\WorkOrderAssignments\\WorkOrderAssignments\\WorkOrderAssignment",
  },
  {
    name: "Work Orders",
    class: "App\\ProDrivers\\WorkOrders\\WorkOrder",
  },
];

export function MeilisearchFlushTool() {
  const { mutateAsync, isPending } = useGqlMutation(flushMeilisearchMutation);
  const [flushedModel, setFlushedModel] = useState<string | null>(null);
  const [disabledModels, setDisabledModels] = useState<Set<string>>(new Set());

  async function handleFlush(modelClass: string, modelName: string) {
    setDisabledModels((prev) => new Set(prev).add(modelClass));
    await mutateAsync({ modelClass });
    setFlushedModel(modelName);
    setTimeout(() => setFlushedModel(null), 3000);
  }

  return (
    <RecordScreenCard title={"Flush Meilisearch Indexes"}>
      <div className="space-y-2">
        <p className="text-sm text-zinc-600">
          Click a button to flush and re-import a Meilisearch index. This will
          dispatch a job to the queue.
        </p>

        {flushedModel ? (
          <div className="rounded-md bg-green-50 p-4">
            <p className="text-sm text-green-800">
              Flush job dispatched for {flushedModel}
            </p>
          </div>
        ) : null}

        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4">
          {SEARCHABLE_MODELS.map((model) => (
            <Button
              key={model.class}
              type="button"
              onClick={() => handleFlush(model.class, model.name)}
              disabled={isPending || disabledModels.has(model.class)}
              className="truncate"
            >
              {model.name}
            </Button>
          ))}
        </div>
      </div>
    </RecordScreenCard>
  );
}
